<template>
  <b-modal ref="modal" no-close-on-backdrop hide-footer no-close-on-esc>
    <template #modal-header>
      <h5>Bitte warten...</h5>
    </template>
    <b-container>
      <b-spinner variant="primary"></b-spinner>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "LoadingModalApp",
  props: {
    show: Boolean,
  },
  mounted() {
    if(this.show) {
      this.$refs["modal"].show()
    } else {
      this.$refs["modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["modal"].toggle()
    }
  }
}
</script>

<style scoped>

</style>